import { Box } from '@mui/material'
import { tokens } from '../theme'

/**
 * A segmented control.
 *
 * Hand-built rather than MUI's ToggleButtonGroup, like every other control in
 * this application: the design system specifies its own resting, hover and
 * selected states, and overriding MUI's into them costs more than the 30
 * lines here.
 */
export function Segmented({
  options, value, onChange, ariaLabel,
}: {
  options: { value: string; label: string }[]
  value: string
  onChange: (value: string) => void
  ariaLabel: string
}) {
  return (
    <Box
      role="group"
      aria-label={ariaLabel}
      sx={{
        display: 'flex', p: 0.5, borderRadius: `${tokens.radius.md}px`,
        backgroundColor: tokens.color.ink100,
      }}
    >
      {options.map((o) => (
        <Box
          key={o.value}
          component="button"
          type="button"
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
          sx={{
            px: 2.5, py: 1, border: 0, cursor: 'pointer', whiteSpace: 'nowrap',
            borderRadius: `${tokens.radius.sm}px`, font: `500 13px ${tokens.font.sans}`,
            backgroundColor: value === o.value ? 'background.paper' : 'transparent',
            boxShadow: value === o.value ? tokens.shadow[1] : 'none',
            color: value === o.value ? 'text.primary' : 'text.secondary',
            transition: `background ${tokens.motion.dur.fast}ms ${tokens.motion.easeStd}`,
          }}
        >
          {o.label}
        </Box>
      ))}
    </Box>
  )
}
